<script lang="ts" setup>
import { DropdownItem, Icon } from '@brighterly/lib-lumee-ui'

import { useLogOut } from '@app/session/log-out.hook'
import { trackEvent } from '@shared/lib/amplitude'

defineOptions({
  name: 'BtnLogOut',
})

const text = 'Logout'

const {
  logout,
} = useLogOut()

const setSubmit = (): void => {
  trackEvent('Button_click', { feature: 'navigation', name: 'log_out', text })
  logout()
}

</script>

<template>
  <DropdownItem
    :title="text"
    role="menuitem"
    :aria-selected="undefined"
    @click="setSubmit"
  >
    <template #leading>
      <Icon
        name="arrow-left-from-bracket"
        size="md"
      />
    </template>
  </DropdownItem>
</template>
